module.exports = __webpack_public_path__ + "img/books.3ae18abb.svg";